import React from "react";
import { Box, Typography, Button } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
const FeaturedProducts = () => {
  return (
    <Box
      sx={{
        py: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: 4,
          width: "100%",
          maxWidth: 1070,
        }}
      >
        <Box sx={{ flex: 1, height: "1px", backgroundColor: "#31B44B" }} />
        <Typography
          className="welcome-title-text"
          variant="h4"
          sx={{
            mx: 3,
            color: "#232323",
          }}
        >
          Featured Products
        </Typography>
        <Box sx={{ flex: 1, height: "1px", backgroundColor: "#31B44B" }} />
      </Box>

      <Button
        variant="contained"
        sx={{
          backgroundColor: "#31B44B",
          color: "white",
          fontWeight: "bold",
          px: 4,
          py: 1.5,
          "&:hover": {
            backgroundColor: "#232323",
          },
          letterSpacing: 2
        }}
        className="dmsans-texts"
      >
        VIEW OUR PRODUCTS
        <PlayArrowIcon />
      </Button>

      <Box
        sx={{
          width: "100%",
          maxWidth: 1070,
          height: "1px",
          backgroundColor: "#31B44B",
          mt: 6,
        }}
      />
    </Box>
  );
};

export default FeaturedProducts;
